import { useTranslation } from 'react-i18next';

import { ActionIcon, Anchor, CheckIcon, CopyButton, Popover, Tooltip } from '@any-ui-react/core';
import classNames from 'classnames';

import { CopyIcon, LinkIcon } from '@anyx/shared-icons';


export interface TrackingLinkDisplayProps {
  target: string;
  title?: string;
  isFocused?: boolean;
}

export const TrackingLinkDisplay = ({ target, title, isFocused }: TrackingLinkDisplayProps) => {
  const { t } = useTranslation('shared');

  return (
    <Popover
      middlewares={{ flip: true, shift: true, inline: true }}
      position="bottom-start"
      width="360"
      withArrow
      arrowPosition="center"
      shadow="md"
    >
      <Popover.Target>
        <span
          className={classNames(
            'inline-flex w-full max-w-max cursor-pointer items-center gap-x-1 space-x-1 rounded-sm border px-1 hover:bg-[#F0F8FF]',
            {
              'bg-[#F0F8FF]': isFocused,
            }
          )}
        >
          <LinkIcon className="text-info h-3 w-3 shrink-0" />
          <span className="text-link truncate text-xs leading-4.5">{title || target}</span>
        </span>
      </Popover.Target>
      {title && (
        <Popover.Dropdown className="flex flex-col gap-y-2 p-3">
          <div className="flex items-center justify-between gap-x-2 text-sm font-semibold">
            {title}

            <CopyButton value={title} timeout={2000}>
              {({ copied, copy }) => (
                <Tooltip
                  label={copied ? t('shared.button.copied') : t('shared.button.copy')}
                  withArrow
                  position="right"
                >
                  <ActionIcon variant="transparent" aria-label="Copy" onClick={copy}>
                    {copied ? (
                      <CheckIcon className="text-success h-4 w-4" />
                    ) : (
                      <CopyIcon className="text-secondary h-4 w-4" />
                    )}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          </div>
          <Anchor className="wrap-anywhere">{target}</Anchor>
        </Popover.Dropdown>
      )}
    </Popover>
  );
};
